
import React, { Component } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ChangingProgressProvider from "./progressProvider";
import Typography from '@material-ui/core/Typography';
import './style.scss';

function syncProgressBarTimer() {
  const time = 90;
  let arrayWithIntervals = [];
  let scale = (100 / time).toFixed(4);
  for (var i = 1; i <= time; i++) {
    arrayWithIntervals.push(Math.round(scale * i))
  }
  return arrayWithIntervals;
}

class ProgressBar extends Component {

  state = {
    valuesIndex: 0,
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({
        valuesIndex: (this.state.valuesIndex + 1) % 90
      });
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.valuesIndex >= 89 || (prevProps.sharingPortalUrl !== '' && prevProps.sharingPortalUrl !== null)) {
      if (prevState.valueIndex >= 89 && prevProps.sharingPortalUrl === null) {
        this.forceUpdate();
      }
      if (prevProps.sharingPortalUrl && prevProps.labId && prevProps.labName && prevProps.id && prevProps.content ) {
        const { sharingPortalUrl, closeModalPopup, labId, labName, id, content } = prevProps;
        let url = '/scportal';
        setTimeout(() => {
          let data = sharingPortalUrl + '~' + labId + '~' + labName + '~' + id + '~' + content;
          window.open(url, data);
          closeModalPopup();
        }, 600);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  render() {
    const { sharingPortalUrl } = this.props;
    return (
      <>
        <div className='progressBar'>
          <ChangingProgressProvider values={syncProgressBarTimer()}>
            {percentage => (
              <CircularProgressbar className='circularBar' value={!sharingPortalUrl ? percentage : 100} text={!sharingPortalUrl ? `${percentage}%` : `100%`} />
            )}
          </ChangingProgressProvider>
        </div>
        <Typography className='info-message' variant="caption" component="div">
          Please wait, your lab is being configured.
        </Typography>
      </>
    )
  }
}

export default ProgressBar;
